import React, { useState } from "react";
import { Check, Loader2, AlertTriangle, Eye, EyeOff, KeyRound, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import * as api from "../api";

// Collegamento di una Pagina Facebook (Messenger) con il Page Access Token
export default function SocialAccountForm({ provider, onAdd }) {
  const [token, setToken] = useState("");
  const [pageId, setPageId] = useState("");
  const [nome, setNome] = useState("");
  const [mostra, setMostra] = useState(false);
  const [connecting, setConnecting] = useState(false);
  const [errore, setErrore] = useState("");

  const collega = async () => {
    if (token.trim().length < 20) {
      setErrore("Incolla il Page Access Token completo della tua Pagina");
      return;
    }
    setErrore("");
    setConnecting(true);
    try {
      const acc = await api.addSocialAccount({ rete: provider.rete, token: token.trim(), page_id: pageId.trim(), label: nome.trim() });
      toast.success(`Pagina "${acc.page_name}" collegata: i messaggi Messenger arrivano nella casella SOCIAL`);
      onAdd(acc);
    } catch (err) {
      setErrore(err?.response?.data?.detail || "Collegamento non riuscito: controlla il token e la connessione");
    } finally {
      setConnecting(false);
    }
  };

  return (
    <div data-testid="social-account-form">
      <div className="wf-field">
        <label className="wf-label">Page Access Token</label>
        <div className="password-box">
          <input
            className="wf-input password-input"
            type={mostra ? "text" : "password"}
            placeholder="EAAG… (token della Pagina)"
            value={token}
            onChange={(e) => { setToken(e.target.value); setErrore(""); }}
            autoFocus
            data-testid="social-token"
          />
          <button className="password-eye" type="button" onClick={() => setMostra((v) => !v)} aria-label={mostra ? "Nascondi token" : "Mostra token"} data-testid="social-token-eye">
            {mostra ? <EyeOff size={19} strokeWidth={2.3} /> : <Eye size={19} strokeWidth={2.3} />}
          </button>
        </div>
      </div>
      <div className="host-port">
        <div className="wf-field">
          <label className="wf-label">Nome della casella</label>
          <input className="wf-input" maxLength={20} placeholder="es. Pagina FB" value={nome} onChange={(e) => setNome(e.target.value)} data-testid="social-label" />
        </div>
        <div className="wf-field">
          <label className="wf-label">ID Pagina (facoltativo)</label>
          <input className="wf-input" placeholder="1000108…" value={pageId} onChange={(e) => setPageId(e.target.value)} data-testid="social-page-id" />
        </div>
      </div>

      {errore && (
        <div className="connect-error" data-testid="social-error">
          <AlertTriangle size={18} strokeWidth={2.4} />
          <span>{errore}</span>
        </div>
      )}

      <div className="wf-modal-actions">
        <button className="wf-btn primary" onClick={collega} disabled={connecting} data-testid="social-submit">
          {connecting ? <><Loader2 size={16} strokeWidth={2.6} className="spin-icon" /> Verifica del token...</> : <><Check size={16} strokeWidth={2.6} /> Collega Pagina</>}
        </button>
      </div>

      <div className="ai-note social-guida" data-testid="social-guida">
        <div style={{ display: "flex", alignItems: "center", gap: 6, fontWeight: 800 }}><KeyRound size={13} /> Come ottenere il token (una volta sola)</div>
        <ol>
          <li>Vai su <a href="https://developers.facebook.com/apps/" target="_blank" rel="noopener noreferrer" data-testid="social-dev-link">developers.facebook.com/apps <ExternalLink size={11} /></a> → <b>Crea app</b> (tipo Business) e aggiungi il prodotto <b>Messenger</b>.</li>
          <li>In Messenger → <b>Impostazioni</b> → <b>Token di accesso</b>: collega la tua Pagina Facebook e premi <b>Genera token</b>.</li>
          <li>Permessi richiesti: <code>pages_messaging</code>, <code>pages_read_engagement</code>, <code>pages_manage_metadata</code>.</li>
          <li>Copia il token e incollalo qui sopra: viene verificato e salvato cifrato.</li>
        </ol>
        <div>Nota: Meta consente di leggere solo i messaggi di una <b>Pagina</b>, non di un profilo personale. Le risposte sono possibili entro 24 ore dall'ultimo messaggio dell'utente.</div>
      </div>
    </div>
  );
}
